import { useLocation, Link } from "react-router-dom";
import { logger } from '@/core/services/logger';
import { useEffect } from "react";
import { Layout } from "@/shared/components/layout/Layout";
import { Button } from "@/shared/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    logger.error("404 Error: User attempted to access non-existent route:", location.pathname);
  }, [location.pathname]);

  return (
    <Layout>
      <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center">
        <div className="text-center space-y-6 px-4">
          <div className="space-y-2">
            <h1 className="text-6xl font-bold text-foreground">404</h1>
            <h2 className="text-2xl font-semibold text-foreground">Page Not Found</h2>
            <p className="text-muted-foreground max-w-md mx-auto">
              The page you're looking for doesn't exist or has been moved. Try one of the links below.
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Button asChild variant="default">
              <Link to="/">
                <Home className="h-4 w-4 mr-2" />
                Go to Dashboard
              </Link>
            </Button>
            <Button asChild variant="outline" onClick={() => window.history.back()}>
              <button>
                <ArrowLeft className="h-4 w-4 mr-2" />
                Go Back
              </button>
            </Button>
          </div>
          <div className="text-sm text-muted-foreground pt-4 space-y-1">
            <p>Common pages:</p>
            <div className="flex flex-wrap gap-3 justify-center">
              <Link to="/campaigns" className="text-primary hover:underline">Campaigns</Link>
              <Link to="/contacts" className="text-primary hover:underline">Contacts</Link>
              <Link to="/gift-cards" className="text-primary hover:underline">Gift Cards</Link>
              <Link to="/forms" className="text-primary hover:underline">Forms</Link>
              <Link to="/settings" className="text-primary hover:underline">Settings</Link>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFound;
